export const FEEDBACK_STEP = {
  workplaces: "workplaces",
  interviewExperience: "interview-experience",
  workplace: "workplace",
  gotOffer: "got-offer",
  gotOfferSubOptions: "got-offer-sub-options",
  notHeardBack: "not-heard-back",
  notHeardBackSubOptions: "not-heard-back-sub-options",
  notOfferTheRole: "not-offer-the-role",
  notOfferConfirmation: "not-offer-confirmation",
  notInterview: "not-interview",
  notInterviewConfirmation: "not-interview-confirmation",
  gotOfferFollowUpSubOptions: "got-offer-follow-up-sub-options",
  gotOfferWithReferral: "got-offer-with-referral",
  freeText: "free-text",
} as const;
export type FeedbackStep = (typeof FEEDBACK_STEP)[keyof typeof FEEDBACK_STEP];
